import {mapRatingScoreToSentiment} from '@travel-frontend/ui-components';

import {REVIEW_SCORE_MAX, REVIEW_SCORE_MAX_BACKEND} from '@/consts';

export const mapHotelCategory = (
  category?: null | number,
  categoryType?: null | string,
  score?: null | number
): string => {
  const ratingAndType = category
    ? `${String(category)} - ${categoryType || ''}`
    : '';
  const scoreToSentiment =
    typeof score === 'number'
      ? `, ${mapRatingScoreToSentiment(
          score / (REVIEW_SCORE_MAX_BACKEND / REVIEW_SCORE_MAX)
        )}`
      : '';
  return ratingAndType + scoreToSentiment;
};
